import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { developerAccessTokenState } from "../global-state";
import "react-toastify/dist/ReactToastify.css";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/material.css";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import WarningIcon from "@mui/icons-material/Warning";
import LoadingSpinner from "../common/loading";
import { SAND_CAT } from "../config";
import { useToast } from "../common/toast";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";

const SchemaUploadView = () => {
  const [developerAccessToken, setDeveloperAccessToken] = useRecoilState(
    developerAccessTokenState,
  );
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const { successToast, warningToast, errorToast } = useToast();
  const [spinButton, setSpinButton] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    loadDevSchemas();
  }, []);

  const loadDevSchemas = async () => {
    setLoading(true);
    const statusUrl = `${SAND_CAT}/schema/read-local`;
    try {
      const response = await fetch(statusUrl, {
        method: "GET",
        headers: { DeveloperAuthorization: `Bearer ${developerAccessToken}` },
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data);
      }
      setFiles(data["files"]);
      console.log(data["files"]);
      setLoading(false);
    } catch (error) {
      errorToast("Error fetching data! Please retry.");
      console.log(error);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 10, hide: true },
    {
      field: "file",
      headerName: "File",
      width: 600,
      sortable: false,
    },
    {
      field: "diff", // active, disabled, error
      headerName: "Diff",
      sortable: false,
      width: 80,
      renderCell: params => {
        return (
          <div>
            {params.row.diff && <WarningIcon style={{ color: "yellow" }} />}
          </div>
        );
      },
    },
  ];

  const handleSaveAndPublish = async () => {
    setSpinButton("upload");
    const selectedFiles = [];
    for (let i = 0; i < selectedRows.length; i++) {
      selectedFiles.push(files[selectedRows[i] - 1].file);
    }
    console.log(selectedFiles);
    try {
      const response = await fetch(`${SAND_CAT}/schema/save-publish`, {
        method: "POST",
        headers: {
          DeveloperAuthorization: `Bearer ${developerAccessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ files: selectedFiles }),
      });
      const jsonData = await response.json();
      if (!response.ok) {
        throw new Error(jsonData);
      }
      if (
        jsonData["notSaved"].length !== 0 ||
        jsonData["savedNotPublished"].length !== 0
      ) {
        errorToast("Some schemas are not saved to draft, or not published.");
      } else {
        successToast("Success.");
      }
    } catch (error) {
      errorToast("Something is wrong! Please retry.");
      console.error("Error saving draft:", error);
    }
    setSpinButton(null);
  };

  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectionChange = newSelection => {
    console.log(newSelection);
    setSelectedRows(newSelection);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Grid container spacing={2} direction="column">
          <Grid container spacing={2}>
            <Box pl={4} pt={4}>
              <Button
                variant="contained"
                onClick={handleSaveAndPublish}
                disabled={spinButton !== null}
              >
                Upload
                {spinButton === "upload" && (
                  <CircularProgress
                    size={20}
                    style={{
                      marginLeft: 10,
                      color: theme.palette.background.l0,
                    }}
                  />
                )}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={10}>
            <Box sx={{ height: "100%", width: "100%" }}>
              <DataGrid
                rows={files}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 20,
                    },
                  },
                  columns: {
                    ...columns,
                    columnVisibilityModel: {
                      id: false,
                    },
                  },
                }}
                pageSizeOptions={[20]}
                rowsPerPageOptions={[20]}
                checkboxSelection
                onRowSelectionModelChange={handleSelectionChange}
                sx={{
                  "& .MuiDataGrid-root": {
                    backgroundColor: theme.palette.background.dataGrid, // Use the theme's background color
                  },
                  "& .MuiDataGrid-cell": {
                    backgroundColor: theme.palette.background.dataGrid,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: theme.palette.background.dataGrid,
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default SchemaUploadView;
